export enum EKwikUIImageType {
  BASE64 = "base64",
  URL = "url"
}

export const VKwikUIImageType = [
  EKwikUIImageType.BASE64,
  EKwikUIImageType.URL
] as const;

export type TKwikUIImageType = (typeof VKwikUIImageType)[number];

export enum EKwikUIImageLoadingType {
  AUTO = "auto",
  LAZY = "lazy",
  EAGER = "eager"
}

export const VKwikUIImageLoadingType = [
  EKwikUIImageLoadingType.AUTO,
  EKwikUIImageLoadingType.LAZY,
  EKwikUIImageLoadingType.EAGER
] as const;

export type TKwikUIImageLoadingType = (typeof VKwikUIImageLoadingType)[number];
